module.exports = __webpack_public_path__ + "static/media/FORMATO CV ATS.3f634ab6.docx";